import { render, staticRenderFns } from "./ProfileAddEdit.vue?vue&type=template&id=1bebdb8a"
import script from "./ProfileAddEdit.vue?vue&type=script&lang=js"
export * from "./ProfileAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports